module.exports = __webpack_public_path__ + "media/photographerOnboarding/bg-e4cf7295.png";